import { render, staticRenderFns } from "./MrMenu.vue?vue&type=template&id=2c561874"
import script from "./MrMenu.vue?vue&type=script&lang=js"
export * from "./MrMenu.vue?vue&type=script&lang=js"
import style0 from "./MrMenu.vue?vue&type=style&index=0&id=2c561874&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports